import type {Vsop87Element, Vsop87Group} from '@app/types/Vsop87Types';

const VSOP87_L0: Vsop87Element = [
    [4.40250710144],
    [0.40989414977, 1.48302034195, 26087.9031415742],
    [0.050462942, 4.47785489551, 52175.8062831484],
    [0.00855346844, 1.16520322459, 78263.70942472259],
    [0.00165590362, 4.11969163423, 104351.61256629678],
    [0.00034561897, 0.77930768443, 130439.51570787099],
    [0.00007583476, 3.71348404924, 156527.41884944518],
    [0.00003559745, 1.51202675145, 1109.3785520934],
    [0.00001803464, 4.10333184211, 5661.3320491522],
    [0.00001726011, 0.35832267096, 182615.32199101939],
    [0.00001589923, 2.9951042356, 25028.521211385],
    [0.00001364681, 4.59918328256, 27197.2816936676],
    [0.00001017332, 0.88031393824, 31749.2351907264],
    [0.00000714182, 1.54144862493, 24978.5245894808],
    [0.00000643759, 5.30266166599, 21535.9496445154],
    [0.00000451137, 6.04989282259, 51116.4243529592],
    [0.000004042, 3.28228953196, 208703.22513259358],
    [0.00000352442, 5.24156372447, 20426.571092422],
    [0.00000345213, 2.79211954198, 15874.6175953632],
    [0.00000343312, 5.7653170387, 955.5997416086],
    [0.00000339215, 5.86327825226, 25558.2121764796],
    [0.00000325329, 1.33674488758, 53285.1848352418],
    [0.00000272948, 2.49451165014, 529.6909650946],
    [0.00000264336, 3.91705105199, 57837.1383323006],
    [0.00000259588, 0.98732774234, 4551.9534970588],
    [0.00000238793, 0.113439144, 1059.3819301892],
    [0.00000234831, 0.26672019191, 11322.6640983044],
    [0.00000216645, 0.65987085507, 13521.7514415914],
    [0.00000208996, 2.09178645677, 47623.8527860896],
    [0.00000183358, 2.62878694178, 27043.5028831828],
    [0.00000181629, 2.43413603252, 25661.3049506982],
    [0.00000175965, 4.53636943501, 51066.427731055],
    [0.00000172642, 2.45200139206, 24498.8302462904],
    [0.00000142317, 3.36004060149, 37410.5672398786],
    [0.00000137943, 0.29098540695, 10213.285546211],
    [0.00000125219, 3.72079967668, 39609.6545831656],
    [0.00000118233, 2.78149967294, 77204.32749453338],
    [0.00000106422, 4.20572143374, 19804.8272915828],
    [0.0000009686, 6.20398934398, 234791.12827416777],
    [0.00000089987, 5.85243663953, 41962.5207369374],
    [0.0000008833, 5.41338287192, 26617.5941066688],
    [0.00000086819, 2.64218953915, 51646.11531805379],
    [0.00000086723, 1.95952945936, 46514.4742339962],
    [0.0000008497, 4.33100839394, 79373.08797681599],
    [0.00000069728, 3.57201999194, 25132.3033999656],
    [0.00000069247, 4.19446500577, 19.66976089979],
    [0.00000068493, 0.63424913908, 83925.04147387479],
];

const VSOP87_L1: Vsop87Element = [
    [26087.90313685529],
    [0.01131199811, 6.21874197797, 26087.9031415742],
    [0.00292242298, 3.04449355541, 52175.8062831484],
    [0.00075775081, 6.08568821653, 78263.70942472259],
    [0.00019676525, 2.80965111777, 104351.61256629678],
];

const VSOP87_L2: Vsop87Element = [
    [0.00016395129, 4.67759555504, 26087.9031415742],
    [0.00008123865, 1.40305644134, 52175.8062831484],
    [0.0000320817, 4.49577853102, 78263.70942472259],
    [0.00001128209, 1.27901273779, 104351.61256629678],
    [0.00000371058, 4.31735787338, 130439.51570787099],
    [0.00000116931, 1.04943307731, 156527.41884944518],
];

const VSOP87_L3: Vsop87Element = [
    [0.00000169496, 3.20221586818, 26087.9031415742],
    [0.00000155725, 6.23814315369, 52175.8062831484],
];

const VSOP87_L4: Vsop87Element = [[0.00000002671, 4.76418299344, 52175.8062831484]];

const VSOP87_L5: Vsop87Element = [];

const VSOP87_B0: Vsop87Element = [
    [0.11737528961, 1.98357498767, 26087.9031415742],
    [0.02388076996, 5.03738959686, 52175.8062831484],
    [0.0054325181, 1.79644363964, 78263.70942472259],
    [0.0012977877, 4.83232503958, 104351.61256629678],
    [0.00031866927, 1.58088495658, 130439.51570787099],
    [0.00007963301, 4.60972126127, 156527.41884944518],
    [0.00002014189, 1.35324164377, 182615.32199101939],
    [0.00000513953, 4.37835406663, 208703.22513259358],
    [0.00000208584, 2.02020295489, 24978.5245894808],
    [0.00000207674, 4.91772567908, 27197.2816936676],
];

const VSOP87_B1: Vsop87Element = [
    [0.00274646065, 3.95008450011, 26087.9031415742],
    [0.00023970726, 2.53272082947, 52175.8062831484],
    [0.00018772047, 0.05141288887, 78263.70942472259],
    [0.00008097508, 3.20946389315, 104351.61256629678],
    [0.00002890729, 0.00943621371, 130439.51570787099],
    [0.00000949669, 3.06780459575, 156527.41884944518],
];

const VSOP87_B2: Vsop87Element = [
    [0.00002747165, 5.24567337999, 26087.9031415742],
    [0.00002047257],
    [0.0000051603, 0.49321133154, 52175.8062831484],
    [0.00000407309, 4.32215500849, 78263.70942472259],
];

const VSOP87_B3: Vsop87Element = [[0.0000006468, 2.16518315874, 26087.9031415742]];

const VSOP87_B4: Vsop87Element = [];

const VSOP87_B5: Vsop87Element = [];

const VSOP87_R0: Vsop87Element = [
    [0.39528271651],
    [0.07834131818, 6.19233722598, 26087.9031415742],
    [0.00795525558, 2.95989690104, 52175.8062831484],
    [0.00121281764, 6.01064153797, 78263.70942472259],
    [0.00021921969, 2.77820093972, 104351.61256629678],
    [0.00004354065, 5.82894543774, 130439.51570787099],
    [0.00000918228, 2.59650562845, 156527.41884944518],
    [0.00000289955, 1.42441937278, 25028.521211385],
    [0.00000260033, 3.02817753901, 27197.2816936676],
    [0.00000201855, 5.64725040577, 182615.32199101939],
    [0.00000201498, 5.59227727403, 31749.2351907264],
    [0.0000014198, 6.25264206514, 24978.5245894808],
    [0.00000100144, 3.73435615066, 21535.9496445154],
    [0.00000077561, 3.66972523786, 20426.571092422],
    [0.000000755, 4.47428643135, 51116.4243529592],
    [0.00000066753, 2.52520325806, 5661.3320491522],
    [0.00000063277, 4.29905566028, 25558.2121764796],
    [0.00000062951, 4.76588960835, 1059.3819301892],
    [0.00000048265, 6.06824353565, 53285.1848352418],
    [0.00000045748, 2.41480951848, 208703.22513259358],
    [0.00000044235, 1.21957279824, 15874.6175953632],
    [0.00000040815, 2.35882025197, 57837.1383323006],
    [0.00000037203, 0.51733923686, 47623.8527860896],
    [0.00000035224, 1.05917819542, 27043.5028831828],
    [0.00000033873, 0.86381554218, 25661.3049506982],
    [0.00000030903, 0.88366672292, 24498.8302462904],
];

const VSOP87_R1: Vsop87Element = [
    [0.0021734774, 4.65617158665, 26087.9031415742],
    [0.00044141826, 1.42385544001, 52175.8062831484],
    [0.00010094479, 4.47466326327, 78263.70942472259],
    [0.00002432805, 1.24226083323, 104351.61256629678],
    [0.00001624367],
    [0.00000603996, 4.29303116468, 130439.51570787099],
];

const VSOP87_R2: Vsop87Element = [
    [0.00003117867, 3.08231840294, 26087.9031415742],
    [0.00001245397, 6.1518331681, 52175.8062831484],
    [0.00000424822, 2.92583350003, 78263.70942472259],
    [0.0000013613, 5.97983927257, 104351.61256629678],
];

const VSOP87_R3: Vsop87Element = [
    [0.00000032676, 1.67971641967, 26087.9031415742],
    [0.00000024166, 4.63403168878, 52175.8062831484],
];

const VSOP87_R4: Vsop87Element = [];

const VSOP87_R5: Vsop87Element = [];

export const VSOP87_X: Vsop87Group = [VSOP87_L0, VSOP87_L1, VSOP87_L2, VSOP87_L3, VSOP87_L4, VSOP87_L5];
export const VSOP87_Y: Vsop87Group = [VSOP87_B0, VSOP87_B1, VSOP87_B2, VSOP87_B3, VSOP87_B4, VSOP87_B5];
export const VSOP87_Z: Vsop87Group = [VSOP87_R0, VSOP87_R1, VSOP87_R2, VSOP87_R3, VSOP87_R4, VSOP87_R5];
